var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/ModelErrorCodeType.ts";
import * as t from 'io-ts';
export var ModelErrorCodeType = t.union([t.literal('Role3DError'), t.literal('ForgeError'), t.literal('AxisError'), t.literal('StructureError'), t.literal('RevitExtractorError'), t.string]);